import { Card, CardActions, CardContent, IconButton, Typography } from '@mui/material';
import React from 'react';
import { ButtonOne } from '../../../components/ButtonOne/ButtonOne.component';
import { AdminCard } from './AdminCards.type';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useHistory } from 'react-router-dom';
import AdminCardBackground from '../../../assets/icons/adminCardBackground.svg';
import TooltipOneComponent from '../../../components/TooltipOne/TooltipOne.component';
import { useTranslation } from 'react-i18next';

interface AdminCardsProps {
  adminCard: AdminCard;
}

export const AdminCards: React.FC<AdminCardsProps> = ({ adminCard }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const handleOnClick = () => {
    history.push(adminCard.link);
  };
  return (
    <Card
      variant="outlined"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        margin: '0.5rem',
        width: 320,
        height: 207,
        color: '#2C2D3E',
        fontSize: '14px',
        fontWeight: 400,
        textAlign: 'center',
        backgroundImage: `url(${AdminCardBackground})`,
        borderRadius: 3,
        cursor: 'pointer',
        '&:hover': {
          background: 'rgba(202, 202, 252, 0.1)',
          border: '1px solid #3C419A',
          backgroundImage: `url(${AdminCardBackground})`,
        },
        border: '1px solid rgba(44, 45, 62, 0.3)',
      }}
      onClick={handleOnClick}
    >
      <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <CardActions>
          <TooltipOneComponent title={adminCard.title} placement="top">
            <IconButton
              disableRipple
              sx={{ backgroundColor: '#D6D6FB', color: '#3C419A' }}
              onClick={handleOnClick}
              aria-label={adminCard.title}
            >
              {adminCard.icon}
            </IconButton>
          </TooltipOneComponent>
        </CardActions>
        <Typography
          variant="h2"
          sx={{ color: '#3C419A', fontWeight: 700, fontSize: 18, marginTop: 0.3, marginBottom: 0.3 }}
        >
          {adminCard.title}
        </Typography>
        <Typography sx={{ color: '#2C2D3E', fontWeight: 400, fontSize: 14 }}>{adminCard.description}</Typography>
      </CardContent>
      <CardActions sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', paddingBottom: 2 }}>
        <ButtonOne
          style={{ color: '#3C419A', fontWeight: 700, height: 25, fontSize: 14, width: 90 }}
          endIcon={<ArrowForwardIosIcon style={{ fontSize: 14 }} />}
          onClick={handleOnClick}
          aria-label={adminCard.ariaLabelMore}
        >
          Więcej
        </ButtonOne>
      </CardActions>
    </Card>
  );
};
